import { computed, ref } from 'vue'

// ── Lo que se ha escrito en la caja de buscar de la documentación ────────────
//
// Vive fuera de los dos componentes porque lo comparten dos: la caja está en el
// armazón (arriba, siempre visible) y lo que filtra está en el armazón Y en el
// índice del medio. Con el término dentro del armazón, escribir «parte» encogía
// el menú de la izquierda y dejaba la rejilla del centro enseñándolo todo —dos
// respuestas distintas a la misma pregunta, en la misma pantalla.
//
// No es un store de Pinia: no hay acciones, no hay servidor y no hay nada que
// reiniciar al cerrar sesión. Es una caja de texto.

export const docsQuery = ref('')

/** Lo que se busca de verdad: sin espacios de sobra y sin mayúsculas. */
export const docsTerm = computed(() => docsQuery.value.trim().toLowerCase())

/**
 * Los grupos que sobreviven a lo que se ha escrito.
 *
 * El nombre del módulo cuenta como coincidencia: quien escribe «clientes» quiere
 * el módulo entero, no sólo el tema que lleve esa palabra suelta.
 *
 * Busca en los títulos y en los resúmenes, que es lo que está cargado. El cuerpo
 * de cada tema se pide al abrirlo —son cientos de kilobytes entre todos— y
 * traérselo entero para poder buscar dentro sería pagar el arranque de la
 * documentación completa para escribir tres letras.
 */
export function filterGroups(groups, term, t) {
  if (!term) return groups

  return groups
    .map(group => ({
      ...group,
      topics: group.label.toLowerCase().includes(term)
        ? group.topics
        : group.topics.filter(topic =>
          `${t(topic.titleKey)} ${topic.summaryKey ? t(topic.summaryKey) : ''}`
            .toLowerCase()
            .includes(term)),
    }))
    .filter(group => group.topics.length)
}
